const API_ENDPOINT = "https://api.campaignsocial.us"
// const API_ENDPOINT = "http://127.0.0.1:5000"
export default API_ENDPOINT
